import React from 'react'
import { useTranslation } from 'react-i18next'

const ClimbingPoints = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>{t('POINTS_TITLE')}</h2>
      <ul className="ul-square">
        <li>
          {t('CLIMBING_POINTS_DANGER')}
          {/* (en savoir +) */}
        </li>
        <li>
          {t('POINTS_RESPECT_ECOSYSTEM')}
          {/* (en savoir +) */}
        </li>
      </ul>
    </div>
  )
}

export default ClimbingPoints
